var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1675.096,
    height: 1358.848,
    viewBox: "0 0 1675.096 1358.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_activities",
    "data-name": "No activities",
    transform: "translate(-3184.829 -6013.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M1568.721,1353.176c243.5-236.792,255.965-599.889-183.586-1007.086-63.752-59.2-94.909-141.644-158.181-185.982C1035.22,25.654,766.073,52.977,596.627,252.62c-92.752,109.289-130.14,259.321-226.486,366.453C262.05,739.386,132.63,856.344,83.5,1020.277c-32.595,108.57-27.082,226.966,10.066,333.139C627.544,1448.325,1132.286,1477.564,1568.721,1353.176Z",
    transform: "translate(3122.777 5936.078)",
    fill: "#c2b59c",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(317 190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(3401 6310.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M450.589,193.773c-3.486,5.329-2.439,11.97,2.8,16.157,28.33,22.646,46,54.559,46,89.879,0,61.953-54.382,113.446-125.237,122.72l-43.1.354c-72.234-8.26-128.086-60.3-128.086-123.074,0-35.327,17.68-67.238,46.012-89.879,5.217-4.179,6.31-10.8,2.835-16.1a82.35,82.35,0,0,1-13.878-48.458C239.8,93.76,291.449,52.509,353.051,53.348S464.486,96.459,464.486,148.29a82.605,82.605,0,0,1-13.9,45.482Z",
    transform: "translate(305.487 -53.335)",
    fill: "#b6ad9d",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M523.414,266.6c-3.489,5.327-2.439,11.97,2.8,16.157,28.33,22.651,46,54.559,46,89.882,0,61.953-54.385,113.446-125.237,122.722l-43.1.35C331.642,487.451,275.79,435.4,275.79,372.637c0-35.327,17.68-67.238,46.012-89.882,5.217-4.176,6.313-10.8,2.835-16.1A82.374,82.374,0,0,1,310.756,218.2c1.866-51.613,53.518-92.864,115.118-92.025s111.437,43.109,111.437,94.945a82.549,82.549,0,0,1-13.9,45.48Z",
    transform: "translate(428.718 38.153)",
    fill: "#b2bfb2",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M552.594,394.519l-36.737,31.159v14.129a3.372,3.372,0,0,1-.038.616V593.348h-43.08V419.9l-.148-.095V309.384c0-10.14,9.514-18.116,21.613-18.116s21.651,7.976,21.651,18.116v64.855l6.453-5.07c8.227-7.265,22.019-7.265,30.284,0C561.223,376.033,561.223,387.626,552.594,394.519ZM241.58,225.552l36.735,31.159v14.127a3.183,3.183,0,0,0,.04.618V584.433h43.08v-333.5l.148-.095V140.42c0-10.142-9.514-18.116-21.613-18.116s-21.653,7.976-21.653,18.116v64.855l-6.453-5.072c-8.227-7.265-22.019-7.265-30.282,0-8.631,6.864-8.631,18.454,0,25.349Z",
    transform: "translate(360.656 68.486)",
    fill: "#abd4ab",
    stroke: "#333",
    strokeWidth: 13,
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M685.84,504.3c-3.871,5.767-11.194,9.366-18.942,9.366H358.411L172.944,201.614l-2.135-3.621c-3.656-6.165-11.153-10.071-19.368-10.092H452.635c7.325,0,14.2,3.245,18.075,8.3l214.266,289.71c4.294,5.765,4.738,12.61.864,18.393Z",
    transform: "translate(218.3 115.717)",
    fill: "#e2dccf",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M261.683,193.979V506.035H141.5A23.67,23.67,0,0,1,123,497.38c-3.874-5.036-3.874-11.9-.872-17.313Zm228.5,312.054H304.713V193.979Z",
    transform: "translate(86.532 123.353)",
    fill: "#c2b59c",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M170.513,201.615h-5.54V477.609l-21.527,36.06V201.615l2.162-3.621c3.655-6.165,11.151-10.071,19.365-10.092l5.54,13.714Z",
    transform: "translate(204.769 115.716)",
    fill: "#978c77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M151.442,187.9c8.214.021,15.711,3.928,19.368,10.092l2.135,3.621V513.67l-21.5-36.06V201.616",
    transform: "translate(218.3 115.717)",
    fill: "#4f432c",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M1014.781,348.6a14.8,14.8,0,0,1,.259,2.565c0,7.944-7.708,14.375-17.19,14.375H31.29a18.97,18.97,0,0,1-12.152-4.2A13.309,13.309,0,0,1,14.1,351.17a15.042,15.042,0,0,1,.258-2.565,14.752,14.752,0,0,1-.258-2.565c0-7.956,7.694-14.407,17.187-14.4H997.85c9.489.007,17.179,6.452,17.19,14.4A14.73,14.73,0,0,1,1014.781,348.6Z",
    transform: "translate(-14.103 296.29)",
    fill: "#c2b59c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_327-2",
    "data-name": "Path 327",
    d: "M450.589,193.773c-3.486,5.329-2.439,11.97,2.8,16.157,28.33,22.646-28.313,49.419-28.313,84.739,0,45.536,43.816,77.266-12.927,103.227-7.64,1.095-16.83-47.607-35.606-45.15H314.975c-72.234-8.26-112.01,9.834-112.01-52.936,0-35.327,17.68-67.238,46.012-89.879,5.217-4.179,6.31-10.8,2.835-16.1a82.35,82.35,0,0,1-13.878-48.458C239.8,93.76,291.449,52.509,353.051,53.348S464.486,96.459,464.486,148.29a82.605,82.605,0,0,1-13.9,45.482Z",
    transform: "translate(3706.486 6257.428)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2",
    "data-name": "Path 328",
    d: "M530.44,266.6c-3.489,5.327-2.439,11.97,2.8,16.157,28.33,22.651,46,54.559,46,89.882,0,61.953-54.385,113.446-125.237,122.722L432.9,487.317c-52.809-66.285-39.163-105.278-124.636-152.478,0-35.327-7.768-29.439,20.565-52.083,5.217-4.176,6.313-10.8,2.835-16.1A82.374,82.374,0,0,1,317.782,218.2c1.866-51.613,53.518-92.864,115.118-92.025s111.437,43.109,111.437,94.945a82.549,82.549,0,0,1-13.9,45.48Z",
    transform: "translate(3822.692 6348.917)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331-2",
    "data-name": "Path 331",
    d: "M688.171,504.3c-3.871,5.767-11.194,9.366-18.942,9.366H358.411L172.944,201.614l-2.135-3.621c-3.656-6.165-11.153-10.071-19.368-10.092H452.635c7.325,0,14.2,3.245,18.075,8.3l216.6,289.71c4.294,5.765,4.738,12.61.864,18.393Z",
    transform: "translate(3619.299 6426.48)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332-2",
    "data-name": "Path 332",
    d: "M252.538,193.979V506.035H100.5A23.67,23.67,0,0,1,82,497.38c-3.874-5.036-3.874-11.9-.872-17.313Zm228.5,312.054H295.568V193.979Z",
    transform: "translate(3496.676 6434.117)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333-2",
    "data-name": "Path 333",
    d: "M170.513,201.615h-5.54V477.609l-21.527,36.06V201.615l2.162-3.621c3.655-6.165,11.151-10.071,19.365-10.092l5.54,13.714Z",
    transform: "translate(3605.768 6419.487)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335-2",
    "data-name": "Path 335",
    d: "M151.442,187.9c8.214.021,15.711,3.928,19.368,10.092l2.135,3.621V513.67l-21.5-36.06V201.616",
    transform: "translate(3619.299 6419.487)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336-2",
    "data-name": "Path 336",
    d: "M1014.781,348.6a14.8,14.8,0,0,1,.259,2.565c0,7.944-7.708,14.375-17.19,14.375H31.29a18.97,18.97,0,0,1-12.152-4.2A13.309,13.309,0,0,1,14.1,351.17a15.042,15.042,0,0,1,.258-2.565,14.752,14.752,0,0,1-.258-2.565c0-7.956,7.694-14.407,17.187-14.4H997.85c9.489.007,17.179,6.452,17.19,14.4A14.73,14.73,0,0,1,1014.781,348.6Z",
    transform: "translate(3386.896 6607.053)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 13
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    transform: "translate(2721.367 6503.934) rotate(-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M1161.5,656.9c35.157-17.2,70.315-35.157,104.723-52.361,2.244,3.74,12.715,19.448,32.165,24.685,2.992.748,23.936,5.236,38.9-5.984,6.732-5.236,5.235-8.976,10.472-17.2,11.22-14.96,29.921-17.952,37.4-19.448,56.1-11.968,79.288-64.329,136.886-60.589,2.244,0,42.637,3.74,50.117,24.684s-22.441,50.117-41.888,64.329c-50.865,37.4-89.762,14.961-129.407,52.361-17.952,17.2-10.473,21.692-36.653,52.361-2.244,2.244-41.889,49.369-72.557,56.849C1254.255,784.807,1196.658,736.934,1161.5,656.9Zm109.21-139.131c-11.968-16.456,52.361-70.313,108.463-133.895,3.74-3.74,11.968-13.464,24.684-15.708s17.205,3.74,27.676,3.74c27.677,0,34.408-45.629,64.329-48.621,17.952-1.5,22.441,11.22,40.394,11.968,35.9,2.244,49.368-55.353,72.556-52.361,16.456,2.244,30.668,29.921,28.425,52.361-.748,8.228-3.74,13.464-30.668,47.125-38.148,46.377-44.133,50.865-50.116,53.857-21.693,11.968-26.929,2.992-50.866,17.2-24.684,14.212-27.676,27.677-41.889,27.677-19.448-.748-26.18-26.929-40.393-23.937-15.708,2.992-12.717,29.173-36.654,44.133-8.975,5.984-15.708,5.236-40.392,8.228C1284.174,516.27,1275.2,524.5,1270.71,517.766Z",
    transform: "translate(-712.992 114.627)",
    fill: "#e1beab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M1613.413,368.307c-25.433-19.449-70.313-47.125-121.926-40.393-35.157,4.488-1.543-97.388-101.611,0s228.775,130.9,260.191,65.078",
    transform: "translate(-1067.664 496.719)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M1252.615,570.639a101.66,101.66,0,0,0-26.927,38.9c-5.236,13.464-7.481,20.2-5.236,24.685,8.228,11.968,55.353-10.472,116.69-34.409,120.43-46.377,139.879-36.653,167.556-68.07,32.912-36.653,14.213-59.093,41.14-121.926,13.465-31.417,65.825-135.391,172.792-160.823,69.565-16.456,163.067,1.5,209.445,63.581,44.88,60.589,33.66,147.359,26.928,201.964-6.732,52.361-21.693,89.762-14.96,92.754,8.228,3.74,38.148-41.141,56.1-85.273,16.456-41.889,47.125-115.194,14.96-192.24-28.424-68.069-89.761-97.99-106.966-106.966-96.494-47.873-190.744-11.968-209.444-5.236-80.786,30.669-122.675,91.258-138.382,114.446-16.457,24.685-30.669,65.825-46.378,104.722-9.723,23.936-17.2,44.133-21.691,58.345C1409.7,519.774,1331.157,545.206,1252.615,570.639Z",
    transform: "translate(-336.598 -103.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M1177.8,799.128c6.733-22.441,20.946-55.353,50.866-77.794,30.668-23.188,50.866-15.708,122.675-38.9,29.172-9.724,66.573-21.692,107.714-47.873a373.155,373.155,0,0,0,68.816-56.849c46.378-1.5,115.195-9.724,188.5-44.881a481.334,481.334,0,0,0,74.8-44.881c.748-26.18,4.488-71.061,26.928-119.682,9.725-20.2,39.645-83.778,110.707-125.666,27.676-16.456,100.234-59.093,185.508-32.913,8.976,2.992,84.526,27.676,119.682,101.73,23.189,48.621,16.456,92.006,5.985,164.563-8.976,60.589-14.213,95.746-41.889,131.651-47.126,60.589-118.186,72.557-131.65,74.8-87.518,14.96-164.564-41.889-215.428-77.794-10.474-7.48-18.7-13.464-23.936-17.952-175.036,39.645-283.5,81.534-350.82,113.7-72.557,35.157-157.083,47.873-221.412,95.746-9.724,7.48-46.376,35.9-65.825,23.937-7.48-4.488-10.472-14.212-11.221-20.944Z",
    transform: "translate(-607.366 -83.705)",
    fill: "#fdbe30",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M1475.229,205.7c14.96,3.74,81.534,21.692,125.667,89.014,7.481,11.968,44.133,69.565,32.165,147.359-2.244,17.2-11.968,80.786-65.077,123.422-65.077,52.361-175.036,57.6-244.6-6.732-82.281-75.55-49.368-193.736-47.873-198.972,21.693-71.809,77.794-108.462,95-118.934,41.889-26.929,82.282-32.913,104.722-35.157Z",
    transform: "translate(-16.017 -53.377)",
    fill: "#e8e1dd",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M1735.908,609.167c2.245,2.992-30.667,17.952-19.446,10.472,11.968-8.228,18.7-11.968,19.447-10.472ZM1635.674,446.848c1.5,3.74-37.4,23.937-97.242,62.085-29.92,19.448-39.644,2.992-8.227-14.96C1593.038,458.816,1634.927,443.856,1635.674,446.848Zm175.783-167.555c-1.495.748-4.487-2.244-9.724-5.984a41.292,41.292,0,0,0-23.936-7.48,72.522,72.522,0,0,0-17.205,2.244,27.638,27.638,0,0,0-8.227,3.74,62.32,62.32,0,0,0-8.976,5.984c-11.968,8.976-21.693,22.441-32.912,38.149-43.386,64.329-83.03,113.7-88.267,109.958s24.686-59.093,68.07-123.422c11.219-16.456,23.936-32.165,39.644-42.637,3.74-2.992,8.228-4.488,12.716-6.732a90.381,90.381,0,0,1,13.465-3.74c8.975-1.5,17.2-1.5,23.936,0,14.213,2.992,24.685,11.22,29.172,17.952,3.74,6.732,3.74,11.968,2.245,11.968Z",
    transform: "translate(-1071.972 219.954)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M1300.932,365c2.992,1.5-.749,14.212-11.221,31.417a205.558,205.558,0,0,1-55.353,56.849,50.211,50.211,0,0,1-12.716,5.984,6.742,6.742,0,0,1-3.74.748,9.485,9.485,0,0,1-4.488.748h-8.976a20.67,20.67,0,0,1-14.213-8.976,34.979,34.979,0,0,1-3.74-7.48,8.138,8.138,0,0,1-.748-3.74c0-1.5-.748-2.992-.748-3.74a72.853,72.853,0,0,1,6.733-38.149c5.236-9.724,11.22-16.456,15.708-20.2,5.235-3.74,8.228-4.488,9.725-2.992,2.244,2.244-5.237,11.968-8.977,29.173a63.133,63.133,0,0,0-.747,29.172v2.244c0,.748.747.748.747,1.5a2.747,2.747,0,0,0,2.244.748h2.242c.749,0,.749,0,1.5-.748,2.245-.748,4.488-2.244,7.48-3.74,22.44-15.708,41.889-33.661,55.354-47.125,11.968-14.212,20.944-23.188,23.936-21.692Zm71.81-5.984c-1.5,0-2.993-2.992-3.741-8.976s.747-14.212,2.245-23.189c2.244-8.976,5.236-20.2,5.984-29.921s-2.244-21.692-8.228-27.677c-2.993-2.992-5.984-3.74-10.472-4.488a27.574,27.574,0,0,0-12.717,3.74,67.8,67.8,0,0,0-11.968,8.228c-3.741,2.992-7.481,6.732-11.221,9.724a65.32,65.32,0,0,1-19.447,13.464c-5.236,2.244-8.976,2.244-9.725.748s.748-4.488,3.74-8.228c2.992-4.488,7.479-10.472,11.968-17.2,2.992-3.74,5.985-8.228,9.725-12.716a73.106,73.106,0,0,1,15.707-13.464c5.984-3.74,14.213-7.48,23.937-7.48a35.956,35.956,0,0,1,27.675,10.472,47.057,47.057,0,0,1,12.717,23.936,81.213,81.213,0,0,1,.747,23.189c-2.244,14.96-8.227,24.684-11.968,32.913s-7.479,14.96-9.724,19.448c-2.245,5.236-3.739,7.48-5.235,7.48Z",
    transform: "translate(-562.943 176.132)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M1381.1,344.622c-1.5.748-4.489-2.244-5.237-8.228-1.5-5.984-.747-14.96,2.993-23.937,2.992-9.724,8.975-19.448,10.472-28.425.747-4.488,1.5-9.724.747-13.464-.747-4.488-2.244-5.984-4.487-7.48s-6.732-1.5-11.969-.748a57,57,0,0,0-14.96,4.488c-8.976,4.488-17.2,10.472-24.685,15.708-13.465,11.22-23.189,18.7-25.433,15.708-2.244-2.244,1.5-12.716,13.465-28.425,5.984-7.48,14.212-16.456,26.18-23.188a64.52,64.52,0,0,1,20.945-8.228c7.479-1.5,17.2-2.244,27.676,2.244a25.028,25.028,0,0,1,11.968,11.22,36.647,36.647,0,0,1,5.235,14.212c1.5,8.976,0,16.456-2.244,23.936a61.255,61.255,0,0,1-8.975,17.2c-2.993,4.488-5.236,8.228-8.229,11.968-4.488,7.48-7.479,12.716-8.975,17.2s-2.245,7.48-4.488,8.228ZM1197.841,451.588c0-3.74,8.228-5.236,17.953-10.472a125.877,125.877,0,0,0,33.661-26.929c11.22-13.464,18.7-28.424,25.432-38.9s11.968-17.2,15.708-15.708c2.993,1.5,3.74,9.724.748,22.44s-8.976,30.669-22.441,47.873c-14.212,17.2-32.913,26.929-47.873,28.424-15.708,1.5-23.937-3.74-23.188-6.732Z",
    transform: "translate(-477.803 148.641)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M1432.261,341.414c-2.245-6.732,22.44-20.2,44.133-44.133,22.441-23.936,34.409-48.621,41.141-47.125,2.992.748,4.488,8.976.748,20.944-2.992,11.968-11.22,28.424-23.936,42.637-13.464,14.212-28.425,23.189-40.393,26.928-11.968,4.488-20.2,3.74-21.693.748Zm69.566,106.966c2.993,1.5-.747,17.2-15.708,38.149a157.473,157.473,0,0,1-31.416,32.164,163.191,163.191,0,0,1-49.368,26.181c-19.448,6.732-38.149,7.48-53.109,9.724-15.708,2.244-27.676,5.984-37.4,11.22-19.448,10.472-23.936,24.684-26.928,23.936-1.5,0-2.992-4.488-.748-11.968,1.5-7.48,7.48-17.952,18.7-26.18a69.852,69.852,0,0,1,19.448-11.22,210.374,210.374,0,0,1,23.189-7.48c16.456-3.74,33.661-5.984,49.369-11.22,32.912-10.472,59.093-29.921,75.549-46.377,16.455-15.708,25.433-28.424,28.424-26.929Zm-13.465-11.22c-.747-1.5.749-5.236-.747-8.228-.747-1.5-1.5-4.488-3.74-5.984-2.244-2.244-4.487-3.74-6.732-3.74-4.489,0-11.221,2.244-18.7,6.732s-16.455,11.22-26.18,17.2c-44.133,28.425-83.03,47.125-86.769,41.141s29.173-33.661,73.305-62.085c9.724-5.984,17.952-11.968,28.425-17.2a106.751,106.751,0,0,1,16.456-5.984c5.984-1.5,11.968-.748,17.952.748a25.027,25.027,0,0,1,15.709,14.212c2.244,5.236,2.992,11.22,1.5,14.96a12.892,12.892,0,0,1-5.984,7.48c-2.993,2.244-4.489,1.5-4.489.748Zm-266.292,71.81c-.748-2.992,4.488-8.228,11.219-15.708A67.342,67.342,0,0,0,1249,459.6c1.5-13.464-2.244-26.929-6.732-35.9s-8.977-14.96-6.733-17.952c1.5-2.992,10.473-1.5,20.946,7.48,9.724,8.976,20.2,27.677,17.2,49.369a60.1,60.1,0,0,1-29.172,44.133C1231.793,513.457,1222.817,511.962,1222.069,508.969Zm-17.205,0c-2.244,2.244-9.725,0-17.952-9.724a52.487,52.487,0,0,1-9.725-19.448,76.152,76.152,0,0,1-2.244-26.181,79.891,79.891,0,0,1,8.228-24.684,51.516,51.516,0,0,1,14.213-16.456c9.724-7.48,17.952-8.228,19.448-5.236s-2.245,8.228-6.732,16.456a128.252,128.252,0,0,0-6.733,14.212c-1.495,5.236-3.74,11.968-4.488,18.7a77.981,77.981,0,0,0,0,18.7c.747,5.984,1.5,11.22,2.993,15.708,2.992,8.976,5.235,15.708,2.992,17.952Z",
    transform: "translate(-627.698 231.887)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M1594.769,262.467c2.245,6.732-90.509,41.889-204.209,86.77s-205.7,83.03-208.7,77.045,84.526-54.6,198.971-99.486c115.194-45.629,211.688-70.313,213.932-64.329Z",
    transform: "translate(-581.511 306.346)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 137.635,
    cy: 11.968,
    rx: 137.635,
    ry: 11.968,
    transform: "matrix(0.95, -0.312, 0.312, 0.95, 971.687, 573.969)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M1483.285,497.85c2.993,5.984-51.612,35.9-124.17,60.589s-133.895,35.157-135.39,28.425,56.1-26.929,127.91-51.613c70.314-23.936,128.658-44.133,131.65-37.4Zm68.07,127.162c1.495-1.5,12.715,16.456,39.645,39.645,13.464,11.968,31.415,23.936,54.605,35.157,23.189,10.472,50.865,18.7,82.281,19.448a222.849,222.849,0,0,0,99.486-20.944c33.661-15.708,64.329-41.141,87.517-75.549s38.9-76.3,49.369-121.178c5.236-22.441,9.724-45.629,11.968-69.565,2.244-23.188,2.244-47.125-3.741-69.565C1962.015,316.83,1930.6,278.682,1894.693,254c-18.7-11.968-38.9-21.692-59.094-27.677-20.944-5.984-41.888-8.228-62.833-8.228-41.141,0-80.786,10.472-114.447,25.432a288.7,288.7,0,0,0-86.021,57.6,283.079,283.079,0,0,0-53.108,67.321,247.938,247.938,0,0,0-24.686,59.841c-8.976,35.157-7.48,55.353-9.725,55.353-.748,0-1.495-5.236-2.244-14.96-.747-5.236,0-11.22,0-17.952,0-3.74.748-7.48.748-11.22.747-3.74.747-8.228,2.244-12.716,2.992-18.7,9.725-40.393,21.693-64.329a282.691,282.691,0,0,1,53.108-73.305,326.764,326.764,0,0,1,89.762-63.581c35.905-16.456,77.794-28.425,122.675-29.173a274.6,274.6,0,0,1,68.817,8.228c23.188,5.984,45.629,16.456,66.573,29.92,20.2,14.212,39.645,31.417,55.353,51.613a250.488,250.488,0,0,1,20.2,33.661c5.236,11.968,10.472,24.684,13.465,37.4,6.732,26.181,5.984,52.361,3.74,77.793s-6.733,48.621-12.717,72.557c-11.219,46.377-27.676,91.258-53.857,128.659a229.618,229.618,0,0,1-44.133,48.621,232.024,232.024,0,0,1-53.109,32.912,229.328,229.328,0,0,1-108.461,19.448,214.975,214.975,0,0,1-87.518-24.684c-23.936-12.716-41.888-26.928-55.353-40.393s-21.693-24.684-26.929-33.661c-5.984-8.228-8.228-13.464-7.479-13.464Z",
    transform: "translate(-309.952 -116.041)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M1618.279,239.1c.748,0,.748,6.732-2.244,17.952s-7.48,26.929-17.205,44.881-23.187,38.9-44.133,56.849-47.873,32.912-79.289,38.9c-31.417,6.732-62.085,4.488-88.266-1.5-26.929-5.984-49.369-15.709-66.574-26.181a204.8,204.8,0,0,1-38.148-29.92c-8.228-8.228-11.219-13.464-11.219-14.212.747-.748,5.235,3.74,14.212,10.472s21.693,16.456,38.9,25.432a243.166,243.166,0,0,0,65.078,23.188c25.433,5.236,54.6,6.732,83.03.748a174.538,174.538,0,0,0,74.8-35.9,184.9,184.9,0,0,0,44.134-52.361c10.472-17.2,15.707-32.165,20.2-42.637,4.487-9.724,5.984-15.708,6.731-15.708Z",
    transform: "translate(-2.122 160.661)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M1651.582,492.681c-.748,0,2.993-8.976,6.732-26.18a251.656,251.656,0,0,0,8.228-71.81c-.747-29.921-8.228-66.573-30.668-100.234a199.408,199.408,0,0,0-41.141-46.377,157.646,157.646,0,0,0-59.094-29.921c-22.44-5.236-44.88-4.488-65.825-.748-21.693,3.74-42.636,8.228-61.337,14.96-38.148,13.464-67.322,35.9-88.266,58.345a232.024,232.024,0,0,0-40.392,59.841c-7.48,15.708-10.473,24.684-11.221,24.684s.748-9.724,6.732-26.18,17.2-39.645,38.149-63.581a214.643,214.643,0,0,1,90.509-62.833c19.449-7.48,41.142-11.968,63.582-15.708s47.125-5.236,71.061.748a159.993,159.993,0,0,1,63.582,32.165,221.222,221.222,0,0,1,43.384,49.369c10.473,17.952,19.449,36.653,23.189,54.605a214.772,214.772,0,0,1,5.984,51.613c-.747,31.417-6.732,56.849-12.715,73.305-4.489,15.708-9.725,23.936-10.473,23.936Zm-351.566,33.661c-1.5.748-5.985-2.992-12.717-11.22-5.984-8.228-12.715-20.945-17.2-35.9s-5.985-29.173-5.237-39.645,2.244-16.456,3.74-16.456c3.741,0,4.488,24.685,13.465,52.361,8.228,27.676,20.944,48.621,17.953,50.865Z",
    transform: "translate(-44.4 -68.984)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 29.173,
    cy: 11.968,
    rx: 29.173,
    ry: 11.968,
    transform: "translate(343.337 838.351) rotate(-35.095)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 38.149,
    cy: 11.968,
    rx: 38.149,
    ry: 11.968,
    transform: "translate(377.403 885.665) rotate(-37.426)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 59.093,
    cy: 11.968,
    rx: 59.093,
    ry: 11.968,
    transform: "translate(723.665 271.228) rotate(-142.636)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 11.968,
    cy: 51.613,
    rx: 11.968,
    ry: 51.613,
    transform: "translate(749.958 107.287)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    transform: "matrix(0.454, 0.891, -0.891, 0.454, 1398.801, 267.233)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.051,
    cy: 9.122,
    rx: 96.051,
    ry: 9.122,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.051,
    cy: 9.122,
    rx: 98.051,
    ry: 11.122,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    transform: "translate(1521.318 315.308) rotate(149)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.053,
    cy: 9.126,
    rx: 96.053,
    ry: 9.126,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.053,
    cy: 9.126,
    rx: 98.053,
    ry: 11.126,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActivity);
export default __webpack_public_path__ + "static/media/noActivity.014817b2e55cb89fc4738a48b8ca0655.svg";
export { ForwardRef as ReactComponent };